import type { MetaFunction } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";

import { blogPostsQuery, employeeQuery } from "~/groq";
import { getClient } from "~/sanity";

import Footer from "~/components/Footer";
import Header from "~/components/Header";
import BlogPreviews from "~/components/blog/BlogPreviews";

export const loader = async () => {
  const posts = await getClient().fetch(blogPostsQuery);
  const employees = await getClient().fetch(employeeQuery);
  return { posts, employees };
};

export const meta: MetaFunction = () => {
  return [
    { title: "Articles | Zest" },
    { name: "description", content: "The people cooking up Zest" },
    { name: "og:description", content: "The people cooking up Zest" },
  ];
};

export default function Blog() {
  const { posts, employees } = useLoaderData<typeof loader>();

  return (
    <main className="overflow-hidden text-text-black">
      <Header />
      <BlogPreviews
        posts={posts}
        authors={employees}
      />
      <Footer />
    </main>
  );
}
